<template>
    <div>
      <div
        uk-grid class="uk-flex uk-flex-middle uk-grid-small search-results-list"
        v-for="(coupon, $key) in coupons"
        v-bind:coupon = "coupon.id"
        v-bind:key="$key"
        v-on:click="clickListItem(coupon.id, coupon.location_id, $event)"
      >
        <div class="logo uk-width-1-5 uk-text-center">
          <img v-bind:src="coupon.image" alt="" style="max-width: 25vw; max-height: 11vh;">
        </div>
        <div class="uk-width-3-5" style="width:70%!important; padding-left: 16vw; overflow: hidden; text-overflow:ellipsis;">
          <span class="font-size-14pt uk-bold" style="/*white-space: nowrap;*/"><strong>{{ coupon.location_name }}</strong></span><br />
          <span class="font-size-13pt" style="/*white-space: nowrap;*/">{{ coupon.name }}</span><br />
        </div>
        <div class="next uk-width-1-5 uk-text-right" style="width: 10% !important;">
          <img src="../../assets/images/right-arrow-grey.png" alt="arrow-right" width="27" height="27">
        </div>
      </div>
    </div>
</template>

<script>
import Hub from '../../events/Hub'
import scrollPointMixin from '../../mixins/scrollPointMixin'

export default {
  mixins: [scrollPointMixin],
  props: ['results'],
  name: 'SearchResultsCoupons',
  methods: {
    clickListItem: function (itemId, locationId, event) {
      this.saveClickLocation(event)
      this.$router.push('/coupons/' + itemId + '/location/' + locationId)
      Hub.$emit('click-list-item')
    },
    getStoreId (coupon) {
      return coupon.stores && coupon.stores.data.length > 0 ? coupon.stores.data[0].id : undefined
    },
    getLocationName (coupon) {
      return coupon.stores && coupon.stores.data.length > 0 ? coupon.stores.data[0].name : ''
    }
  },
  computed: {
    coupons () {
      return this.results.map(item => {
        let newItem = {...item}

        newItem.location_id = this.getStoreId(item)
        newItem.location_name = this.getLocationName(item)

        return newItem
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Search/SearchResultsCoupons.vue